<template>
  <div
    :class="{ focusInSelect: focusInSelect }"
    class="rt-address"
  >
    <div class="address-select-all">
      <div class="address-select">
        <el-select
          v-model="address.province[alias.id]"
          :disabled="computedDisabled"
          :placeholder="
            computedDisabled
              ? computedEmptyPlaceholder
              : $tx('省', 'xpc.address.province')
          "
          :filterable="filterable"
          :filter-method="filterMethod"
          @focus="focus1"
          @blur="blur1"
          @change="provinceChange"
          @keydown.native="handleProvinceKeydown"
        >
          <el-option
            v-for="(item, index) in provinces"
            :key="index"
            :label="item[alias.name]"
            :value="item[alias.id]"
          >
            <div v-html="highlightKey(item[alias.name])"></div>
          </el-option>
        </el-select>
        <rt-icon
          v-if="!computedDisabled"
          :color="SCSS_VARIABLES.COLOR_INFO"
          name="rt-base-dropdown"
        />
      </div>
      <div class="address-select">
        <el-select
          v-model="address.city[alias.id]"
          :disabled="computedDisabled"
          :placeholder="
            computedDisabled
              ? computedEmptyPlaceholder
              : $tx('市', 'xpc.address.city')
          "
          :filterable="filterable"
          :filter-method="filterMethod"
          @focus="focus2"
          @blur="blur2"
          @change="cityChange"
          @keydown.native="handleCityKeydown"
        >
          <el-option
            v-for="(item, index) in cities"
            :key="index"
            :label="item[alias.name]"
            :value="item[alias.id]"
          >
            <div v-html="highlightKey(item[alias.name])"></div>
          </el-option>
        </el-select>
        <rt-icon
          v-if="!computedDisabled"
          :color="SCSS_VARIABLES.COLOR_INFO"
          name="rt-base-dropdown"
        />
      </div>
      <div class="address-select">
        <el-select
          v-model="address.country[alias.id]"
          :disabled="computedDisabled"
          :placeholder="
            computedDisabled
              ? computedEmptyPlaceholder
              : $tx('县/区', 'xpc.address.county')
          "
          :filterable="filterable"
          :filter-method="filterMethod"
          @focus="focus3"
          @blur="blur3"
          @change="countryChange"
        >
          <el-option
            v-for="(item, index) in countries"
            :key="index"
            :label="item[alias.name]"
            :value="item[alias.id]"
          >
            <div v-html="highlightKey(item[alias.name])"></div>
          </el-option>
        </el-select>
        <rt-icon
          v-if="!computedDisabled"
          :color="SCSS_VARIABLES.COLOR_INFO"
          name="rt-base-dropdown"
        />
      </div>
      <div
        :class="{ focusInSelect: focusInSelect }"
        class="rt-input-shadow"
      />
    </div>
    <div class="address-input">
      <rt-input
        v-model="address.address"
        :disabled="computedDisabled"
        :placeholder="computedInputPlaceholder"
        :clearable="computedClearable"
        :clear-icon-name="clearIconName"
        :clear-icon-right="clearIconRight"
        @focus="focusInput"
        @blur="blurInput"
        @change="addressChange"
        @click="inputChange"
      />
      <div
        :class="{ focusInInput: focusInInput }"
        class="rt-input-shadow"
      />
    </div>
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon';
import RtInput from '../form/rtInput';
import config from '../../config';
import ElSelect from 'vue-xpc/src/element-ui/packages/select/src/select.vue';
import addressData from '../../libs/address/address';
import Placeholder from '../form/placeholder.js';

export default {
  name: 'RtAddress',
  components: {
    RtIcon,
    RtInput,
    ElSelect
  },
  mixins: [Placeholder],

  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否可以清空选项
    clearable: {
      type: Boolean,
      default: undefined
    },
    // 自定义清空按钮图标
    clearIconName: {
      type: String,
      default: undefined
    },
    // 自定义清空按钮位置
    clearIconRight: {
      type: Number,
      default: 0
    },
    filterable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      selected1: false,
      selected2: false,
      selected3: false,
      focusInInput: false,
      address: {
        province: {},
        city: {},
        country: {}
      },
      provinces: [],
      cities: [],
      countries: [],
      config: {},
      alias: {},
      provinceFilterable: false,
      cityFilterable: false,
      countryFilterable: false,
      keyWord: ''
    };
  },
  inject: {
    elForm: {
      default: ''
    }
  },
  computed: {
    computedClearable () {
      return this.clearable === undefined
        ? this.elForm &&
            this.elForm.$attrs &&
            this.elForm.$attrs['all-clearable']
        : this.clearable;
    },
    computedIconName () {
      return this.clearIconName || config.get('clearicon.clearIconName');
    },
    computedClearIconStyle () {
      let style = {};
      if (this.computedClearable) {
        style['marginRight'] =
          this.clearIconRight || config.get('clearicon.clearIconRight') + 'px';
      }
      return style;
    },
    computedDisabled () {
      return this.disabled || (this.elForm || {}).disabled;
    },
    focusInSelect () {
      return (
        this.selected1 || this.selected2 || this.selected3 || this.focusInInput
      );
    }
  },
  watch: {
    value (newValue, oldValue) {
      if (JSON.stringify(newValue) === JSON.stringify(oldValue)) return;
      const { province, city, country, address } = JSON.parse(
        JSON.stringify(newValue)
      );
      if (province) {
        this.address.province = province;
        this.provinceChange();
      }
      if (city) {
        this.address.city = city;
        this.cityChange();
      }
      if (country) {
        this.address.country = country;
        this.countryChange();
      }
      this.address.address = address;
      this.addressChange();
    }
  },
  mounted () {
    this.getProvinces();
  },
  methods: {
    handleProvinceKeydown (event) {
      const keyCode = event.keyCode;

      // Tab
      if (keyCode === 9) {
        if (this.address.province[this.alias.id]) {
          this.cityFilterable = true;
        }
      }
    },

    handleCityKeydown (event) {
      const keyCode = event.keyCode;

      // Tab
      if (keyCode === 9) {
        if (this.address.city[this.alias.id]) {
          this.countryFilterable = true;
        }
      }
    },

    inputChange () {
      this.address.city = {};
      this.address.country = {};
      this.address.province = {};
      this.address.address = '';
    },
    async getProvinces () {
      this.config = config.get();
      this.alias = this.config.address.alias;
      let provinceUrl = this.config.address.provinceUrl;
      this.provinces = provinceUrl
        ? await rt.get(provinceUrl)
        : addressData.filter(item => {
          return item.ParentId === '';
        });
    },
    async getCities () {
      let citiesUrl = this.config.address.cityUrl;
      let _config = {
        id: this.address.province[this.alias.id],
        params: {
          id: this.address.province[this.alias.id]
        }
      };
      const cityData = citiesUrl
        ? await rt.get(citiesUrl, _config)
        : addressData;
      this.cities = cityData.filter(item => {
        return item.ParentId === this.address.province[this.alias.id];
      });
      this.countries = [];
    },
    async getCountries () {
      let countriesUrl = this.config.address.countyUrl;
      let _config = {
        id: this.address.city[this.alias.id],
        params: {
          id: this.address.city[this.alias.id]
        }
      };
      const countriesData = countriesUrl
        ? await rt.get(countriesUrl, _config)
        : addressData;
      this.countries = countriesData.filter(item => {
        return item.ParentId === this.address.city[this.alias.id];
      });
    },
    provinceChange () {
      this.address.city = {};
      this.address.country = {};
      this.address.address = '';
      let { province } = this.address;
      if (province) {
        if (province[this.alias.id] && !province[this.alias.name]) {
          province[this.alias.name] = this.findNameById(
            'provinces',
            province[this.alias.id]
          );
        }
        if (!province[this.alias.id] && province[this.alias.name]) {
          province[this.alias.id] = this.findIdByName(
            'provinces',
            province[this.alias.name]
          );
        }
        this.getCities();
        this.change();
      }
    },
    cityChange () {
      this.address.country = {};
      this.address.address = '';
      let { city } = this.address;
      if (city) {
        if (city[this.alias.id] && !city[this.alias.name]) {
          city[this.alias.name] = this.findNameById(
            'cities',
            city[this.alias.id]
          );
        }
        if (!city[this.alias.id] && city[this.alias.name]) {
          city[this.alias.id] = this.findIdByName(
            'cities',
            city[this.alias.name]
          );
        }
        this.getCountries();
        this.change();
      }
    },
    countryChange () {
      this.address.address = '';
      let { country } = this.address;
      if (country) {
        if (country[this.alias.id] && !country[this.alias.name]) {
          country[this.alias.name] = this.findNameById(
            'countries',
            country[this.alias.id]
          );
        }
        if (!country[this.alias.id] && country[this.alias.name]) {
          country[this.alias.id] = this.findIdByName(
            'countries',
            country[this.alias.name]
          );
        }
        this.change();
      }
    },
    addressChange () {
      this.change();
    },
    change () {
      this.$emit('input', this.address);
    },
    focus1 () {
      this.selected1 = true;
      this.provinceFilterable = true;
    },
    blur1 () {
      this.keyWord = '';
      this.selected1 = false;
      this.provinceFilterable = false;
    },
    focus2 () {
      this.selected2 = true;
    },
    blur2 () {
      this.keyWord = '';
      this.selected2 = false;
      this.cityFilterable = false;
    },
    focus3 () {
      this.selected3 = true;
    },
    blur3 () {
      this.keyWord = '';
      this.selected3 = false;
      this.countryFilterable = false;
    },
    focusInput () {
      this.focusInInput = true;
    },
    blurInput () {
      this.focusInInput = false;
    },
    highlightKey (text) {
      const reg = new RegExp(this.keyWord, 'g');
      return text
        ? text.replace(
          reg,
          `<span style='color:#ff9500;'>${this.keyWord}</span>`
        )
        : '';
    },
    filterMethod (key) {
      this.keyWord = key;
    },
    findIdByName (type, name) {
      const { alias } = this;
      return (
        this[type] &&
        this[type].find(item => item[alias.name] === name)[alias.id]
      );
    },
    findNameById (type, id) {
      const { alias } = this;
      return (
        this[type] && this[type].find(item => item[alias.id] === id)[alias.name]
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtAddress.vue?2836a27d